import React, { useCallback } from 'react';

import { withArrayFormField } from '@gogame/form';

import { CostModelPreviews, TYPE } from 'scenes/Campaigns/components/CostModel';

export const CostModels = withArrayFormField()(({
  push,
  value,
  remove,
  replace,
  canAddCostModel,
  CostModelFormCreate,
  CostModelFormEdit,
  campaignId,
  platformName,
  fullWidthItem,
  removableCostModels,
  name,
}) => {
  const handleCanRemove = useCallback(
    (costModel) => {
      return removableCostModels || costModel[TYPE].isRemovable;
    },
    [removableCostModels]
  );

  const handAdd = (costModel) => {
    push({
      ...costModel,
      [TYPE]: {
        ...costModel[TYPE],
        isRemovable: true,
      },
    });
  };

  return (
    <CostModelPreviews
      models={value}
      onAdd={handAdd}
      onRemove={remove}
      onEdit={replace}
      canRemove={handleCanRemove}
      canAddCostModel={canAddCostModel}
      CostModelFormCreate={CostModelFormCreate}
      CostModelFormEdit={CostModelFormEdit}
      campaignId={campaignId}
      platformName={platformName}
      fullWidthItem={fullWidthItem}
      name={name}
    />
  );
});
